module.exports = __webpack_public_path__ + "img/user_logo.055948eb.svg";